import { CreditCheckResponse } from "src/api-service";

// **************************************************************************
// SUBSCRIPTION CREDIT CHECK STATE
// Used during subscription creation to check customer creditworthiness
// before creating a quote.
// **************************************************************************

export interface SubscriptionCreditCheckState {
    result: CreditCheckResponse | null;
    loading: boolean;
    // Core Super User override of a denied result (no status masquerade — the
    // real Denied status + score/limit are preserved on `result`).
    overridden: boolean;
}

export const initialSubscriptionCreditCheckState: SubscriptionCreditCheckState = {
    result: null,
    loading: false,
    overridden: false,
};

// **************************************************************************
// QUOTE CREDIT CHECK LOADING STATE
// The actual credit check result is stored on the Quote object itself,
// but we track loading state here for the quote flow.
// **************************************************************************

export interface QuoteCreditCheckLoadingState {
    running: boolean;
    overriding: boolean;
}

export const initialQuoteCreditCheckLoadingState: QuoteCreditCheckLoadingState = {
    running: false,
    overriding: false,
};

// **************************************************************************
// COMBINED CREDIT CHECK STATE
// **************************************************************************

export interface CreditCheckState {
    subscription: SubscriptionCreditCheckState;
    quoteLoading: QuoteCreditCheckLoadingState;

    // Credit checks list
    creditChecks: CreditCheckResponse[];
    creditChecksLoading: boolean;
}

export const initialCreditCheckState: CreditCheckState = {
    subscription: initialSubscriptionCreditCheckState,
    quoteLoading: initialQuoteCreditCheckLoadingState,
    creditChecks: [],
    creditChecksLoading: false,
};
